export class RadarProvider {
  async listOpportunities() {
    throw new Error("RadarProvider.listOpportunities must be implemented.");
  }
}
